import {combineReducers} from '@reduxjs/toolkit';

import {userDatasetEntitlementsStateSlice} from './slices/user-dataset-entitlements-state.slice';
import {userDatasetEntitlementsSlice} from './slices/user-dataset-entitlements.slice';

export const userDatasetEntitlementsAssignedReducer = combineReducers({
    entitlements: userDatasetEntitlementsSlice.reducer,
    state: userDatasetEntitlementsStateSlice.reducer,
});
